<template>
  <div class='wrapping'>
      <vue-home-index-pc v-if="deviceType==='pc'"></vue-home-index-pc>
      <vue-home-index-mobile v-if="deviceType==='mobile'"></vue-home-index-mobile>
  </div>
</template>

<script>
import HomeIndexPc from '@/views/home/lang/kr/pc'
import HomeIndexMobile from '@/views/home/lang/kr/mobile'

export default {
  name: 'HomeIndex',
  components: {
    'vue-home-index-pc': HomeIndexPc,
    'vue-home-index-mobile': HomeIndexMobile
  },
  created () {
    this.initEnv()
  },
  data () {
    return {
      deviceType: ''
    }
  },
  methods: {
    // 初始过环境
    initEnv () {
      if (this.isPC()) {
        this.deviceType = 'pc'
      } else {
        this.deviceType = 'mobile'
      }
    },
    // 判断pc端还是移动端
    isPC () {
      var userAgentInfo = navigator.userAgent

      var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']

      var flag = true

      for (var i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) > 0) {
          flag = false

          break
        }
      }

      return flag
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/home/lang/kr/index.vue